// extracted by mini-css-extract-plugin
export var image = "styles-module--image--c089b";
export var mainContent = "styles-module--main-content--220be";
export var suptitle = "styles-module--suptitle--4aad2";
export var wrapper = "styles-module--wrapper--eafed";